import { useCreateIncidentContext, useUserLanguage } from '@/customHooks'
import textsData from '@/textData/CreateIncidentTexts.json'
import { IncidentCategoryOption } from '@/graphql/generated'
import { Col, Row } from 'react-grid-system'
import { SquareButtonsCard } from '../molecules';
import { useEffect, useMemo } from 'react';

import lockIcon from '@/assets/incidents-icons/lock-icon.svg'
import electricityIcon from '@/assets/incidents-icons/electricity-icon.svg'
import woodCarpIcon from '@/assets/incidents-icons/wood-carpentry-icon.svg'
import metalCarpIcon from '@/assets/incidents-icons/metal-carpentry-icon.svg'
import waterIcon from '@/assets/incidents-icons/water-icon.svg'
import constructionIcon from '@/assets/incidents-icons/construction-icon.svg'
import internetIcon from '@/assets/incidents-icons/internet-icon.svg'
import garderingIcon from '@/assets/incidents-icons/gardering-icon.svg'
import cleaningIcon from '@/assets/incidents-icons/cleaning-icon.svg'
import gasIcon from '@/assets/incidents-icons/gas-icon.svg'
import otherIcon from '@/assets/incidents-icons/other-icon.svg'
import checkIcon from '@/assets/incidents-icons/check-icon.svg'

export const SelectIncidentCategoryMenu = () => {
  const userLanguage = useUserLanguage();

  const texts = userLanguage === 'es' ? textsData.es.incidentCategory : textsData.en.incidentCategory

  const { state, setCategory, setButtonEnabled, setButtonDisabled } = useCreateIncidentContext()

  const buttons = [
    { text: texts.button.button1, icon: lockIcon },
    { text: texts.button.button2, icon: electricityIcon },
    { text: texts.button.button3, icon: woodCarpIcon },
    { text: texts.button.button4, icon: metalCarpIcon },
    { text: texts.button.button5, icon: waterIcon },
    { text: texts.button.button6, icon: constructionIcon },
    { text: texts.button.button7, icon: internetIcon },
    { text: texts.button.button8, icon: garderingIcon },
    { text: texts.button.button9, icon: cleaningIcon },
    { text: texts.button.button10, icon: gasIcon },
    { text: texts.button.button11, icon: otherIcon },
    { text: texts.button.button12, icon: checkIcon },
  ];

  const defaultSelectedIndex = useMemo(() => {
    switch (state.incidentCategory) {
      case IncidentCategoryOption.Lock: return 0;
      case IncidentCategoryOption.Electricity: return 1;
      case IncidentCategoryOption.WoodCarpentry: return 2;
      case IncidentCategoryOption.MetalCarpentry: return 3;
      case IncidentCategoryOption.Water: return 4;
      case IncidentCategoryOption.Construction: return 5;
      case IncidentCategoryOption.Internet: return 6;
      case IncidentCategoryOption.Gardering: return 7;
      case IncidentCategoryOption.Cleaning: return 8;
      case IncidentCategoryOption.Gas: return 9;
      case IncidentCategoryOption.Other: return 10;
      case IncidentCategoryOption.Checkout: return 11;
      default: return null;
    }
  }, [state.incidentCategory]);

  useEffect(() => {
    if (state.incidentCategory) {
      setButtonEnabled();
    } else {
      setButtonDisabled();
    }
  }, [state.incidentCategory, setButtonEnabled, setButtonDisabled]);

  const onSelectedHandle = (value: number | null) => {
    switch (value) {
      case null:
        setButtonDisabled()
        break

      case 0:
        setCategory(IncidentCategoryOption.Lock)
        setButtonEnabled()
        break
      
      case 1:
        setCategory(IncidentCategoryOption.Electricity)
        setButtonEnabled()
        break
      
      case 2:
        setCategory(IncidentCategoryOption.WoodCarpentry)
        setButtonEnabled()
        break

      case 3:
        setCategory(IncidentCategoryOption.MetalCarpentry)
        setButtonEnabled()
        break
      
      case 4:
        setCategory(IncidentCategoryOption.Water)
        setButtonEnabled()
        break

      case 5:
        setCategory(IncidentCategoryOption.Construction)
        setButtonEnabled()
        break

      case 6:
        setCategory(IncidentCategoryOption.Internet)
        setButtonEnabled()
        break
      
      case 7:
        setCategory(IncidentCategoryOption.Gardering)
        setButtonEnabled()
        break

      case 8:
        setCategory(IncidentCategoryOption.Cleaning)
        setButtonEnabled()
        break

      case 9:
        setCategory(IncidentCategoryOption.Gas)
        setButtonEnabled()
        break
      
      case 10:
        setCategory(IncidentCategoryOption.Other)
        setButtonEnabled()
        break
      
      case 11:
        setCategory(IncidentCategoryOption.Checkout)
        setButtonEnabled()
        break

      default:
        throw new Error('Select value for IncidentType is invalid [SelectIncidentTypeMenuCard]')
    }
  }
  
  return (
      <Row justify="center">
        <Col xs='content'>
          <SquareButtonsCard
            buttons={buttons}
            onSelected={onSelectedHandle}
            defaultSelected={defaultSelectedIndex}
          />
        </Col>
      </Row>
  );
}